import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=0084c5e8&scoped=true&"
import script from "./Resources.vue?vue&type=script&lang=js&"
export * from "./Resources.vue?vue&type=script&lang=js&"
import style0 from "./Resources.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Resources.vue?vue&type=style&index=1&id=0084c5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0084c5e8",
  null
  
)

export default component.exports